import React from 'react'
import { Redirect } from 'react-router-dom'

class CouponRedirect extends React.PureComponent {
  render() {
    // console.log("this.props")
    // console.log(this.props)
    if (this.props.location && this.props.location.search) {
      const coupon_id = this.props.location.search.replace('?coupon_id=', '')
      return <Redirect to={{ pathname: `/tests`, state: {coupon_id: coupon_id} }} />
    } else {
      return ''
    }
  }
}

export default CouponRedirect



// WEBPACK FOOTER //
// ./src/js/components/CouponRedirect.js